import { useAuth } from 'react-oidc-context';
import { useToPreviewTrainingTools } from '../hooks/usePreviewTrainingTools';
import { useEffect, useState } from 'react';
import { DoctorTrainingToolsItem } from '../interface/interface';
import { TrainingToolPreviewer } from './TrainingToolPreviewer';
import Loading from './Loading';
import { TrainingToolTile } from './TrainingToolTile';

export function TrainingToolCards({
  resources,
}: {
  resources: DoctorTrainingToolsItem[];
}) {
  const { user } = useAuth();
  const {
    handlePreviewFiles,
    previewUrl,
    profileName,
    previewBlob,
    closePreview,
    activeButtonIndex,
    isPreviewLoading,
  } = useToPreviewTrainingTools(user!.access_token);
  const [open, setOpen] = useState<boolean>(false);
  const [isVideo, setIsVideo] = useState<boolean>(false);

  useEffect(() => {
    if (!previewBlob) return;

    if (previewBlob.type.startsWith('video/')) {
      setOpen(true);
      setIsVideo(true);
      return;
    }
    setOpen(false);
    setIsVideo(false);
  }, [previewBlob]);

  if (isPreviewLoading) {
    return <Loading />;
  }

  return (
    <div>
      <ul role="list" className="divide-y divide-gray-100">
        {resources?.map((resource, index) => (
          <TrainingToolTile
            key={index}
            resource={resource}
            handlePreviewFiles={handlePreviewFiles}
            activeButtonIndex={activeButtonIndex}
          />
        ))}
      </ul>

      {previewBlob ? (
        <TrainingToolPreviewer
          open={open}
          isVideo={isVideo}
          previewUrl={previewUrl}
          profileName={profileName}
          previewBlob={previewBlob}
          closePreview={closePreview}
          setOpen={setOpen}
          isAdmin={(user?.profile.groups as string[])?.includes('Admin')}
        />
      ) : null}
    </div>
  );
}
